<template>
  <div id="profile-history-stats">
	<div v-if="profilePerformanceDisputeData.disputeCounts !== undefined && profilePerformanceDisputeData.disputeCounts.total > 0" class="performance-display">
		<div>
			<apexChart type="pie" width="380" id="historical-profile-performance" :options="options" :series="performanceSeries"></apexChart>
			<div class="dispute-total">
				<label for="historical-profile-performance">Total Disputes Processed</label>
				<div>{{ profilePerformanceDisputeData.disputeCounts.total.toLocaleString(undefined) }}</div>
				<v-btn>View Full Report</v-btn>
			</div>
		</div>
		<div class="profile-performance-review">
			<h3>Profile Performance Review</h3>
			<div class="dispute-cards">
				<v-card class="card">
					<v-card-text>
						<div class="card-header">Paid Disputes Total</div>
					</v-card-text>	
						<div class="total-paid">${{ disputeAmounts["pay"] % 1 ? disputeAmounts["pay"].toFixed(2) : disputeAmounts["pay"]}}</div>
				</v-card>
				<v-card class="card">
					<v-card-text>
						<div class="card-header">Paid Disputes Average</div>
					</v-card-text>	
						<div class="average">${{ paidDisputeAverage % 1 ? paidDisputeAverage.toFixed(2) : paidDisputeAverage }}</div>
				</v-card>
			</div>
			<div class="performance-breakdowns">
				<div class="breakdown">
					<div class="line-header">Amount Breakdown</div>
					<div class="breakdown-grid">
						<div>Paid:</div>
						<div class="amount">${{ disputeAmounts["pay"] % 1 ? disputeAmounts["pay"].toFixed(2) : disputeAmounts["pay"] }}</div>
						<div>Denied:</div>
						<div class="amount">${{ disputeAmounts["deny"] % 1 ? disputeAmounts["deny"].toFixed(2) : disputeAmounts["deny"] }}</div>
						<div>Referred:</div>
						<div class="amount">${{ disputeAmounts["refer"] % 1 ? disputeAmounts["refer"].toFixed(2) :disputeAmounts["refer"] }}</div>
					</div>
				</div>
				<div class="breakdown">
					<div class="line-header">Decision Breakdown</div>
					<div class="breakdown-grid">
						<div>Paid:</div>
						<div class="count">{{ performanceSeries[0].toLocaleString(undefined) }}</div>
						<div>Denied:</div>
						<div class="count">{{ performanceSeries[1].toLocaleString(undefined) }}</div>
						<div>Referred:</div>
						<div class="count">{{ performanceSeries[2].toLocaleString(undefined) }}</div>
					</div>
				</div>
				
			</div>
		</div>
	</div>
	<div v-else-if="performanceSeries.length > 0" class="empty-performance-history">
		<h3>No Performance History Found</h3>
		<img class="empty-state-graphic" src="@/assets/imgs/empty-box.svg">
	</div>
	<div v-else>
		<v-skeleton-loader type="image"></v-skeleton-loader>
	</div>
  </div>
</template>

<script>
	/**
	 * @fileoverview profile-histoy-stats.vue displays the dispute statistics for the selected profile.
	 * It relies on vuex to map the state variables from the store files.
	 * 
	 * @author Sophia Frankel <sophia.frankel@quavo.com>
	 */
	import { mapState } from 'vuex';

export default {
	data() {
		return {
			/**
			 * Options for the dispute pie chart
			 */
			options: {
				chart: {
					dropShadow: {
						enabled: true,
						bottom: 5,
						left: 0,
						blur: 3,
						opacity: 0.5
					},
				},
				legend: {
					show: false
				},
				colors: ['#4EA674', '#AE2727', '#C98724'],
				labels: ["Pay", "Deny", "Refer"],
				dataLabels: {
					style: {
						fontSize: '1em',
						fontFamily: 'Avenir, Helvetica, Arial, sans-serif',
					},
					formatter: function(val) {
						return (val.toString().includes(".") ? val.toFixed(1) : val) + "%";
						//return val + "%" + "\n" + opt.w.globals.labels[opt.seriesIndex];
					},
				},
				plotOptions: {
					pie: {
						customScale: 1
					}
				}
			},
		}
	},
	computed: {
		...mapState({
			profilePerformanceDisputeData: (state) => state.config.profilePerformanceDisputeData,
			performanceSeries: (state) => state.config.profilePerformanceSeries,
			disputeAmounts: (state) => state.config.profilePerformanceDisputeAmounts,
			paidDisputeAverage: (state) => state.config.profilePerformancePaidDisputeAverage,
		}),
	},
}
</script>

<style>

</style>